export default "__VITE_ASSET__d1004a23__"